import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { API, errorText } from '../governance_v2/constants';
import { VERDICT_META } from './constants';

const EMPTY = { title: '', lesson: '', module_type: '', kpi: '', verdict: 'sin_resultado', outcome_summary: '' };

export const NewMemoryDialog = ({ companyId, open, onClose }) => {
  const qc = useQueryClient();
  const [f, setF] = useState(EMPTY);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const create = useMutation({
    mutationFn: () => axios.post(`${API}/companies/${companyId}/memory`, {
      title: f.title, lesson: f.lesson, module_type: f.module_type || null, verdict: f.verdict, outcome_summary: f.outcome_summary,
      kpi_names: f.kpi.split(',').map((k) => k.trim()).filter(Boolean) }),
    onSuccess: () => { toast.success('Lección creada como borrador'); qc.invalidateQueries({ queryKey: ['memory'] }); setF(EMPTY); onClose(); },
    onError: (e) => toast.error(errorText(e)),
  });
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="memory-new-dialog">
        <DialogHeader><DialogTitle>Nueva lección manual</DialogTitle></DialogHeader>
        <div className="grid gap-3">
          <div className="space-y-1"><Label className="text-xs">Título</Label><Input value={f.title} onChange={set('title')} data-testid="memory-new-title" /></div>
          <div className="space-y-1"><Label className="text-xs">Lección</Label><Textarea rows={3} value={f.lesson} onChange={set('lesson')} data-testid="memory-new-lesson" /></div>
          <div className="space-y-1"><Label className="text-xs">Resultado (qué pasó)</Label><Textarea rows={2} value={f.outcome_summary} onChange={set('outcome_summary')} data-testid="memory-new-outcome" /></div>
          <div className="grid grid-cols-3 gap-3">
            <div className="space-y-1"><Label className="text-xs">Módulo</Label><Input placeholder="finanzas" value={f.module_type} onChange={set('module_type')} data-testid="memory-new-module" /></div>
            <div className="space-y-1"><Label className="text-xs">KPIs (coma)</Label><Input value={f.kpi} onChange={set('kpi')} data-testid="memory-new-kpis" /></div>
            <div className="space-y-1"><Label className="text-xs">Veredicto</Label>
              <Select value={f.verdict} onValueChange={(v) => setF({ ...f, verdict: v })}>
                <SelectTrigger data-testid="memory-new-verdict"><SelectValue /></SelectTrigger>
                <SelectContent>{['exito', 'parcial', 'fracaso', 'sin_resultado'].map((v) => <SelectItem key={v} value={v}>{VERDICT_META[v].label}</SelectItem>)}</SelectContent>
              </Select></div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="memory-new-cancel">Cancelar</Button>
          <Button onClick={() => create.mutate()} disabled={create.isPending || f.title.trim().length < 3 || f.lesson.trim().length < 10} data-testid="memory-new-submit">Crear borrador</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
